// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3D8ZX","abort":"style_abort__ILl70","submit":"style_submit__sUac5"};